<template>
  <div>
    <a-form layout="inline" :form="form" style="margin:0 0 20px 24px;">
      <a-form-item label="短信签名">
        <a-select v-model="signatureId" style="width: 200px" @change="handleChange">
          <a-select-option
            v-for="item in options"
            :key="item.signatureId"
            :value="item.signatureId">{{ item.signatureContent }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item style="margin-left:1%;">
        <a-button type="primary" @click="onSave" :loading="saveing">保存</a-button>
      </a-form-item>
      <a-form-item>
        *保存设置后，签名将作为后续发送短信时生效
      </a-form-item>
    </a-form>
    <custom-page-table
      ref="table"
      :columns="columns"
      :queryParams="queryParams"
      base-key="smsUrl"
      params-path="sign/getSignatureInfoPage"
    >
    </custom-page-table>
  </div>
</template>

<script>
export default {
  name: 'SmsComponent',
  data() {
    return {
      columns: [
        {
          title: 'ID',
          dataIndex: 'signatureId'
        },
        {
          title: '签名时间',
          dataIndex: 'signatureContent'
        },
        {
          title: '提交时间',
          dataIndex: 'createTime'
        },
        {
          title: '状态',
          dataIndex: 'status'
        },
        {
          title: '备注',
          dataIndex: 'signatureRemarks'
        }
      ],
      saveing: false,
      queryParams: {},
      form: this.$form.createForm(this),
      options: [],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      signatureId: ''
    }
  },
  created() {
    let platformConfig = this.getPlatformConfig()
    this.queryParams = {
      merchantId: this.merchantId,
      platformId: this.platformId
    }
  },
  mounted() {
    this.getSignatureInfoList()
    this.selectDefaultSign()
  },
  methods: {
    //获取选择器项列表
    getSignatureInfoList() {
      this.getHttpServices().getSmsApiService().post('sign/getSignatureInfoList/', {
        merchantId: this.merchantId,
        platformId: this.platformId
      })
        .then(res => {
          this.options = res
          this.getLogUtils().logWithTag('options---------------', this.options)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleChange(value) {
      this.signatureId = value
      this.getLogUtils().logWithTag('签名内容ID', this.signatureId)
    },
    //获取默认ID
    selectDefaultSign() {
      this.getHttpServices().getSmsApiService().post('sign/selectDefaultSign/', {
        merchantId: this.merchantId,
        platformId: this.platformId
      })
        .then(res => {
          this.signatureId = res.signatureId
          this.getLogUtils().logWithTag('this.signatureId', this.signatureId)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onSave() {
      if (this.signatureId) {
        let url = '/sign/updateDefaultSign/' + this.signatureId
        this.getHttpServices().getSmsApiService().post(url, {
          merchantId: this.merchantId,
          platformId: this.platformId
        })
          .then(res => {
            this.getLogUtils().logWithTag('======selectDefaultSign======', res)
            this.$message.success('设置成功')
            this.saveing = true
            setTimeout(() => {
              this.saveing = false
            }, 1000)
          }).catch(reason => {
          this.$message.error('设置失败')
          this.saveing = true
          setTimeout(() => {
            this.saveing = false
          }, 1000)
          this.showNetWorkErrorMessage(reason)
        })
      }
    },
    searchBts() {
      this.$refs.table.refresh(true)
    }
  }
}
</script>
<style scoped>
</style>
